import { useState } from "react";
import { Phone, MessageCircle, MapPin, Clock, Send } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { phoneTel, waLink } from "../../lib/constants";
import { useSettings } from "../../lib/SettingsContext";

const inputCls =
  "w-full bg-[#0A0A0A] border border-[#28282D] rounded-lg px-4 py-3 text-sm text-white placeholder:text-zinc-600 focus:border-yellow-400 outline-none transition-colors";

export const Contact = () => {
  const s = useSettings();
  const [loc, setLoc] = useState("");
  const [car, setCar] = useState("");
  const [issue, setIssue] = useState("");

  const msg = `السلام عليكم، أحتاج خدمة بنشر متنقل.\nموقعي: ${loc}\nنوع السيارة: ${car}\nالمشكلة: ${issue}`;

  return (
    <section id="contact" data-testid="contact-section" className="py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            kicker="اتصل بنا"
            title="نجم الإطارات في خدمتك"
            desc="اتصل مباشرة أو ابنِ رسالتك الجاهزة وأرسلها واتساب — نختصر عليك الأسئلة ونوصل أسرع."
          />
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-8 mt-12">
          <Reveal>
            <div className="h-full bg-[#121214] border border-[#28282D] rounded-2xl p-8 space-y-6">
              <a data-testid="contact-phone-link" href={phoneTel(s.phone_display)} className="flex items-center gap-4 group">
                <span className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                  <Phone className="w-6 h-6 text-black" />
                </span>
                <div>
                  <div className="text-xs text-zinc-500">اتصل الآن</div>
                  <div className="font-display font-bold text-xl text-white group-hover:text-yellow-400 transition-colors" dir="ltr">{s.phone_display}</div>
                </div>
              </a>
              <a data-testid="contact-whatsapp-link" href={waLink(msg, s.whatsapp)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 group">
                <span className="w-12 h-12 rounded-xl bg-green-500/15 border border-green-500/40 flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                  <MessageCircle className="w-6 h-6 text-green-400" />
                </span>
                <div>
                  <div className="text-xs text-zinc-500">واتساب</div>
                  <div className="font-display font-bold text-xl text-white group-hover:text-green-400 transition-colors" dir="ltr">{s.phone_display}</div>
                </div>
              </a>
              <div className="flex items-center gap-4">
                <span className="w-12 h-12 rounded-xl bg-[#0A0A0A] border border-[#28282D] flex items-center justify-center shrink-0">
                  <MapPin className="w-6 h-6 text-yellow-400" />
                </span>
                <div>
                  <div className="text-xs text-zinc-500">نطاق الخدمة</div>
                  <div className="font-bold text-white">{s.location_text}</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-12 h-12 rounded-xl bg-[#0A0A0A] border border-[#28282D] flex items-center justify-center shrink-0">
                  <Clock className="w-6 h-6 text-yellow-400" />
                </span>
                <div>
                  <div className="text-xs text-zinc-500">ساعات العمل</div>
                  <div className="font-bold text-white">{s.hours}</div>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="h-full bg-[#121214] border border-yellow-400/30 rounded-2xl p-8">
              <div className="flex items-center gap-2 mb-6">
                <MessageCircle className="w-5 h-5 text-green-400" />
                <h3 className="font-display font-bold text-lg text-white">واتساب ذكي — رسالة جاهزة</h3>
              </div>
              <div className="space-y-4">
                <input data-testid="wa-location-input" value={loc} onChange={(e) => setLoc(e.target.value)} placeholder="موقعك (الحي أو رابط اللوكيشن)" className={inputCls} />
                <input data-testid="wa-car-input" value={car} onChange={(e) => setCar(e.target.value)} placeholder="نوع السيارة — مثال: تويوتا كامري" className={inputCls} />
                <input data-testid="wa-issue-input" value={issue} onChange={(e) => setIssue(e.target.value)} placeholder="المشكلة — مثال: بنشر، بطارية، كفر منفجر" className={inputCls} />
              </div>
              <div data-testid="wa-preview" className="mt-5 bg-[#0A0A0A] border border-[#28282D] rounded-xl p-4 text-sm text-zinc-400 whitespace-pre-line leading-relaxed min-h-[110px]">
                {msg}
              </div>
              <a
                data-testid="wa-send-btn"
                href={waLink(msg, s.whatsapp)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 w-full flex items-center justify-center gap-2 bg-green-500 text-white font-bold px-6 py-3.5 rounded-full hover:bg-green-400 transition-colors"
              >
                <Send className="w-5 h-5" />
                إرسال عبر واتساب
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
